export default {
  group: [
    {
      name: 'personal_data',
      fields: [
        {
          name: 'full_name',
          type: 'text',
          mask: null,
          column_type: 'full-row',
        },
        {
          name: 'edrpou',
          type: 'number',
          mask: null,
          column_type: 'full-row',
        },
        {
          name: 'department',
          type: 'text',
          mask: null,
          column_type: 'full-row',
        },
        {
          name: 'position',
          type: 'text',
          mask: null,
          column_type: 'full-row',
        },
      ],
    },
    {
      name: 'contact_data',
      fields: [
        {
          name: 'working_phone_number',
          type: 'text',
          mask: 'phone',
          column_type: 'one-third-row',
        },
        {
          name: 'working_email',
          type: 'text',
          mask: 'email',
          column_type: 'one-third-row',
        },
      ],
    },
  ],
};
